import React from 'react';
import { Block, FlexRow, Title } from '../content';
import { getEventIcon } from './utils';
const AgendaEventField = ({
  event,
  descriptions
}) => {
  return /*#__PURE__*/React.createElement(FlexRow, {
    margin: 0,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FlexRow, {
    xs: 12,
    lg: 11,
    margin: 0
  }, /*#__PURE__*/React.createElement(Title, {
    xs: 12,
    lg: 4,
    md: 4,
    margin: 0,
    title: event.name,
    description: descriptions.eventName
  }), /*#__PURE__*/React.createElement(Title, {
    xs: 12,
    lg: 4,
    md: 4,
    margin: 0,
    title: event.user?.email || event?.visitatore?.email || event.email,
    description: descriptions.email
  }), /*#__PURE__*/React.createElement(Title, {
    xs: 12,
    lg: 4,
    md: 4,
    margin: 0,
    title: event?.resources?.[0]?.name,
    description: descriptions.resource
  })), /*#__PURE__*/React.createElement(Block, {
    xs: 0,
    lg: 1,
    margin: 0,
    textAlign: "right"
  }, getEventIcon(event)));
};
export default AgendaEventField;